import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

export const fetchBrokerForm = () => {
  const companyIDToken = companyToken();
  const data = {
    ...(companyIDToken ? { company_id_token: companyIDToken } : {}),
  };
  const params = new URLSearchParams(data).toString();
  return fetchWithCSRFToken(appendAuthParams(`/api/v1/broker_forms?${params}`), {});
};
